import { apiClient } from './client';
import { endpoints } from './endpoints';

export interface WbCameraConfigView {
  anpr_mode: 'http_snapshot' | 'rtsp' | null;
  anpr_endpoint: string | null;
  anpr_username: string | null;
  anpr_has_password: boolean;
  anpr_min_confidence: number;
  anpr_weight_threshold_kg: number | null;
}

export interface WbCameraConfigUpdate {
  anpr_mode?: 'http_snapshot' | 'rtsp' | null;
  anpr_endpoint?: string | null;
  anpr_username?: string | null;
  anpr_password?: string | null;
  anpr_min_confidence?: number;
  anpr_weight_threshold_kg?: number | null;
}

export interface AnprLogEntry {
  id: number;
  plate_read: string;
  confidence: number;
  vehicle_enc_id: string | null;
  vehicle_registration: string | null;
  triggered_by: 'weight_threshold' | 'manual';
  created_at: string;
}

export interface AnprLogResponse {
  entries: AnprLogEntry[];
}

export async function getWbCameraConfig(weighbridgeEncId: string): Promise<WbCameraConfigView> {
  const res = await apiClient.get<WbCameraConfigView>(
    endpoints.wb.cameraConfig(weighbridgeEncId),
  );
  return res.data;
}

export async function updateWbCameraConfig(
  weighbridgeEncId: string,
  data: WbCameraConfigUpdate,
): Promise<{ ok: boolean }> {
  const res = await apiClient.patch<{ ok: boolean }>(
    endpoints.wb.cameraConfig(weighbridgeEncId),
    data,
  );
  return res.data;
}

export async function getAnprLog(weighbridgeEncId: string): Promise<AnprLogResponse> {
  const res = await apiClient.get<AnprLogResponse>(
    endpoints.wb.anprLog(weighbridgeEncId),
  );
  return res.data;
}
